/**
 * Live suggestions for the search results page bar.
 * Same idea as header predictive search: section HTML + SKU catalog merge.
 */
(function() {
  'use strict';

  var MIN_CHARS = 2;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function expandQuery(query) {
    if (window.SearchSkuSuggestions && window.SearchSkuSuggestions.shopifySkuSearchQuery) {
      return window.SearchSkuSuggestions.shopifySkuSearchQuery(query);
    }
    return query;
  }

  function whenSkuReady(callback, attempt) {
    attempt = attempt || 0;
    if (window.SearchSkuSuggestions && typeof window.SearchSkuSuggestions.search === 'function') {
      callback(window.SearchSkuSuggestions);
      return;
    }
    if (attempt >= 40) {
      callback(null);
      return;
    }
    setTimeout(function() {
      whenSkuReady(callback, attempt + 1);
    }, 50);
  }

  function fetchSectionHtml(query) {
    var expanded = expandQuery(query);
    var url =
      root() +
      'search/suggest?q=' + encodeURIComponent(expanded) +
      '&section_id=search-page-suggestions' +
      '&resources[limit]=10' +
      '&resources[limit_scope]=each' +
      '&resources[type]=query,product,collection,page,article';

    return fetch(url, { credentials: 'same-origin' })
      .then(function(res) {
        if (!res.ok) throw new Error('suggest failed');
        return res.text();
      })
      .then(function(text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.querySelector('.shopify-section') || doc.body;
        var inner = section.querySelector('.sps-dropdown-inner');
        if (inner) return inner.innerHTML;
        return section ? section.innerHTML : '';
      })
      .catch(function() {
        return '';
      });
  }

  function fetchSkuProducts(query, handle) {
    return new Promise(function(resolve) {
      whenSkuReady(function(api) {
        if (!api) {
          resolve([]);
          return;
        }
        api.search(query, { collectionHandle: handle, limit: 8 })
          .then(function(products) { resolve(products || []); })
          .catch(function() { resolve([]); });
      });
    });
  }

  function mergeHtml(sectionInnerHtml, skuProducts, query) {
    var api = window.SearchSkuSuggestions;
    var hasSku = skuProducts && skuProducts.length;
    var hasSection = sectionInnerHtml && String(sectionInnerHtml).trim();

    if (api && typeof api.mergeSpsDropdown === 'function' && hasSku) {
      return api.mergeSpsDropdown(hasSection ? sectionInnerHtml : '', skuProducts, query);
    }

    if (hasSection) {
      return '<div class="sps-dropdown-inner">' + sectionInnerHtml + '</div>';
    }

    if (api && typeof api.buildSpsProductItems === 'function' && hasSku) {
      return api.mergeSpsDropdown('', skuProducts, query);
    }

    return '<div class="sps-dropdown-inner"><p class="sps-no-results">No results found. Try product name or SKU (2+ characters).</p></div>';
  }

  function bindBar(bar) {
    if (bar.dataset.spsBound === 'true') return;
    bar.dataset.spsBound = 'true';

    var input = bar.querySelector('[data-search-page-input]');
    var panel = bar.querySelector('[data-search-page-suggestions]');
    if (!input || !panel) return;

    var handle = bar.getAttribute('data-search-catalog-handle') || 'all-jewelry';
    var timer = null;
    var requestId = 0;

    function hidePanel() {
      panel.setAttribute('hidden', '');
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function showPanel(html) {
      panel.innerHTML = html || '';
      if (!html) {
        hidePanel();
        return;
      }
      panel.removeAttribute('hidden');
      input.setAttribute('aria-expanded', 'true');
    }

    function runSearch(query) {
      var id = ++requestId;
      Promise.all([
        fetchSectionHtml(query),
        fetchSkuProducts(query, handle)
      ]).then(function(results) {
        if (id !== requestId) return;
        if ((input.value || '').trim() !== query) return;
        var html = mergeHtml(results[0], results[1], query);
        if (!html || !String(html).trim()) {
          html = '<div class="sps-dropdown-inner"><p class="sps-no-results">No results found. Try product name or SKU (2+ characters).</p></div>';
        }
        showPanel(html);
      });
    }

    input.addEventListener('input', function() {
      clearTimeout(timer);
      var q = (input.value || '').trim();
      if (q.length < MIN_CHARS) {
        hidePanel();
        return;
      }
      timer = setTimeout(function() {
        runSearch(q);
      }, 200);
    });

    input.addEventListener('focus', function() {
      var q = (input.value || '').trim();
      if (q.length >= MIN_CHARS) {
        if (panel.innerHTML) {
          panel.removeAttribute('hidden');
          input.setAttribute('aria-expanded', 'true');
        } else {
          runSearch(q);
        }
      }
    });

    document.addEventListener('click', function(e) {
      if (!bar.contains(e.target)) hidePanel();
    });

    if (window.SearchSkuSuggestions && window.SearchSkuSuggestions.preload) {
      window.SearchSkuSuggestions.preload(handle);
    }
  }

  function bindAll() {
    document.querySelectorAll('[data-search-page-bar]').forEach(bindBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  document.addEventListener('shopify:section:load', bindAll);
})();
